/* ══ SARTORIA ASOLANA — THEME JS ═════════════════════════ */
/* Portato da shared.js di Timi. Carrello ricablato su Shopify
   AJAX Cart API (/cart/*.js) invece di PRODUCTS+localStorage.
   Slider hero, marquee, announcement, appear-on-scroll, nav: 1:1. */

const SA = window.SA || {};
const money = (cents) =>
  (window.Shopify && Shopify.formatMoney)
    ? Shopify.formatMoney(cents, SA.moneyFormat || '€{{amount}}')
    : '€' + (cents / 100).toLocaleString('it-IT', { minimumFractionDigits: 2 });

/* ── CART (Shopify AJAX) ─────────────────────────────────── */
const FREE_SHIP = (SA.freeShipThreshold != null ? SA.freeShipThreshold : 20000); // cents

async function cartGet() {
  const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
  return r.json();
}
async function addToCart(variantId, qty = 1) {
  try {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] }),
    });
    if (!r.ok) {
      const e = await r.json().catch(() => ({}));
      showToast(e.description || 'Articolo non disponibile');
      return;
    }
    await refreshCart();
    showToast('Aggiunto al carrello');
    openCart();
  } catch (e) {
    showToast('Errore di rete');
  }
}
async function cChange(key, qty) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty }),
  });
  await refreshCart();
}
const cQty = (key, d) => {
  const row = document.querySelector(`[data-key="${key}"]`);
  const cur = row ? parseInt(row.getAttribute('data-qty'), 10) : 1;
  cChange(key, Math.max(0, Math.min(10, cur + d)));
};
const cRm = (key) => cChange(key, 0);

function updateBadge(count) {
  const el = document.getElementById('cbadge');
  if (!el) return;
  el.textContent = count;
  el.style.display = count > 0 ? 'flex' : 'none';
  if (count > 0) {
    el.classList.add('pop');
    setTimeout(() => el.classList.remove('pop'), 300);
  }
}

function renderDrawer(cart) {
  const body = document.getElementById('dr-body');
  const foot = document.getElementById('dr-foot');
  if (!body || !foot) return;
  const sub = cart.items_subtotal_price;
  const pct = Math.min(100, Math.round((sub / FREE_SHIP) * 100));
  const pf = document.getElementById('prog-fill');
  const pl = document.getElementById('prog-lbl');
  if (pf) pf.style.width = pct + '%';
  if (pl) {
    pl.innerHTML =
      sub >= FREE_SHIP
        ? '🎉 Spedizione gratuita applicata!'
        : `Aggiungi <strong>${money(FREE_SHIP - sub)}</strong> per la spedizione gratuita`;
  }
  if (!cart.item_count) {
    body.innerHTML = `<div class="dr-empty"><div class="dr-empty-icon">🛍</div><div class="dr-empty-txt">Carrello vuoto</div><a href="${SA.routes.allProducts}" class="lnk" style="margin:0 auto">Scopri la Collezione →</a></div>`;
    foot.innerHTML = '';
    return;
  }
  body.innerHTML = cart.items
    .map(
      (it) => `<div class="dr-item" data-key="${it.key}" data-qty="${it.quantity}">
    <div class="di-img"><img src="${it.image ? it.image.replace(/(\.[^.]+)$/, '_160x$1') : ''}" alt="${it.product_title}"></div>
    <div>
      <div class="di-name">${it.product_title}</div>
      <div class="di-meta">${it.variant_title ? it.variant_title : ''}</div>
      <div class="di-price">${money(it.final_line_price)}</div>
      <div class="di-qty-row">
        <div class="di-qty"><button class="di-qbtn" onclick="cQty('${it.key}',-1)">−</button><div class="di-qval">${it.quantity}</div><button class="di-qbtn" onclick="cQty('${it.key}',1)">+</button></div>
      </div>
      <button class="di-rm" onclick="cRm('${it.key}')">Rimuovi</button>
    </div>
  </div>`
    )
    .join('');
  const freeShip = cart.items_subtotal_price >= FREE_SHIP;
  foot.innerHTML = `
    <div class="df-row"><span class="lbl">Subtotale</span><span>${money(cart.items_subtotal_price)}</span></div>
    <div class="df-row"><span class="lbl">Spedizione</span><span style="${freeShip ? 'color:var(--gold)' : ''}">${freeShip ? 'Gratuita' : 'Calcolata al checkout'}</span></div>
    <div class="df-row df-total"><span class="lbl">Totale</span><span>${money(cart.total_price)}</span></div>
    <form action="/cart" method="post"><button class="btn-fill" style="width:100%;margin-top:18px" type="submit" name="checkout">Procedi all'Acquisto</button></form>
    <div style="text-align:center;margin-top:12px"><button class="lnk" onclick="closeCart()">Continua lo Shopping</button></div>`;
}

async function refreshCart() {
  const cart = await cartGet();
  updateBadge(cart.item_count);
  renderDrawer(cart);
}
function openCart() {
  document.getElementById('drawer').classList.add('open');
  document.getElementById('dov').classList.add('open');
}
function closeCart() {
  document.getElementById('drawer').classList.remove('open');
  document.getElementById('dov').classList.remove('open');
}

/* ── TOAST ───────────────────────────────────────────────── */
let toastT;
function showToast(m) {
  const el = document.getElementById('toast');
  if (!el) return;
  el.textContent = m;
  el.classList.add('show');
  clearTimeout(toastT);
  toastT = setTimeout(() => el.classList.remove('show'), 2700);
}

/* ── APPEAR ON SCROLL ────────────────────────────────────── */
function initAppear() {
  const obs = new IntersectionObserver(
    (es) => {
      es.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          obs.unobserve(e.target);
        }
      });
    },
    { threshold: 0.07 }
  );
  const vh = window.innerHeight;
  document.querySelectorAll('.sr, .ap').forEach((el) => {
    if (el.classList.contains('in')) return;
    const r = el.getBoundingClientRect();
    if (r.top < vh && r.bottom > 0) {
      el.classList.add('in');
    } else {
      obs.observe(el);
    }
  });
}

/* ── SCROLL + NAV ────────────────────────────────────────── */
function initScroll(transpOnTop) {
  window.addEventListener(
    'scroll',
    () => {
      const bar = document.getElementById('sbar');
      if (bar) {
        const m = document.documentElement.scrollHeight - window.innerHeight;
        bar.style.width = (m > 0 ? (window.scrollY / m) * 100 : 0) + '%';
      }
      const nav = document.getElementById('main-nav');
      if (nav) {
        nav.classList.toggle('scrolled', window.scrollY > 10);
        if (transpOnTop) nav.classList.toggle('over-hero', window.scrollY < 80);
      }
    },
    { passive: true }
  );
}

/* ── ANNOUNCEMENT BAR ────────────────────────────────────── */
function initAnn() {
  const msgs = document.querySelectorAll('.ann-msg');
  if (msgs.length < 2) return;
  let i = 0;
  setInterval(() => {
    msgs[i].classList.remove('active');
    i = (i + 1) % msgs.length;
    msgs[i].classList.add('active');
  }, 4500);
}

/* ── HERO SLIDER ─────────────────────────────────────────── */
function initHeroSlider() {
  const root = document.getElementById('hero-slider');
  if (!root) return;
  const slides = root.querySelectorAll('.slide');
  const dotsWrap = document.getElementById('slider-dots');
  if (slides.length === 0) return;
  let cur = 0,
    timer,
    paused = false;
  const DUR = 5500;

  slides.forEach((_, i) => {
    const d = document.createElement('div');
    d.className = 'sdot' + (i === 0 ? ' active' : '');
    d.addEventListener('click', () => go(i));
    dotsWrap.appendChild(d);
  });

  function go(n) {
    slides[cur].classList.remove('active');
    const oldFill = slides[cur].querySelector('.slide-progress-fill');
    if (oldFill) {
      oldFill.style.transition = 'none';
      oldFill.style.width = '0%';
    }
    document.querySelectorAll('.sdot')[cur].classList.remove('active');
    cur = (n + slides.length) % slides.length;
    const ns = slides[cur];
    ns.classList.add('active');
    ['.slide-eyebrow', '.slide-h1', '.slide-row'].forEach((sel) => {
      const el = ns.querySelector(sel);
      if (el) {
        el.style.animation = 'none';
        el.offsetHeight;
        el.style.animation = '';
      }
    });
    const fill = ns.querySelector('.slide-progress-fill');
    if (fill) {
      fill.style.transition = 'none';
      fill.style.width = '0%';
      fill.offsetHeight;
      fill.style.transition = 'width ' + DUR / 1000 + 's linear';
      fill.style.width = '100%';
    }
    document.querySelectorAll('.sdot')[cur].classList.add('active');
    clearInterval(timer);
    if (!paused) timer = setInterval(() => go(cur + 1), DUR);
  }

  const prev = document.getElementById('sarr-prev');
  const next = document.getElementById('sarr-next');
  if (prev) prev.addEventListener('click', () => go(cur - 1));
  if (next) next.addEventListener('click', () => go(cur + 1));

  root.addEventListener('mouseenter', () => {
    paused = true;
    clearInterval(timer);
  });
  root.addEventListener('mouseleave', () => {
    paused = false;
    timer = setInterval(() => go(cur + 1), DUR);
  });

  let touchX = 0;
  root.addEventListener('touchstart', (e) => (touchX = e.touches[0].clientX), { passive: true });
  root.addEventListener(
    'touchend',
    (e) => {
      const diff = touchX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) go(diff > 0 ? cur + 1 : cur - 1);
    },
    { passive: true }
  );

  if (slides.length > 1) timer = setInterval(() => go(cur + 1), DUR);
  const f0 = slides[0].querySelector('.slide-progress-fill');
  if (f0) {
    f0.offsetHeight;
    f0.style.transition = 'width ' + DUR / 1000 + 's linear';
    f0.style.width = '100%';
  }
}

/* ── INIT ────────────────────────────────────────────────── */
function initPage(transpNav) {
  refreshCart();
  initAnn();
  initScroll(transpNav || false);
  if (transpNav) {
    const nav = document.getElementById('main-nav');
    if (nav) nav.classList.add('over-hero');
  }
  initHeroSlider();
  setTimeout(initAppear, 100);
}

document.addEventListener('DOMContentLoaded', () => {
  const dov = document.getElementById('dov');
  if (dov) dov.addEventListener('click', closeCart);
  initPage(document.body.hasAttribute('data-transparent-nav'));
});
